import React from "react"
export const ShipmentUnLoadingDetailContext = React.createContext(null);

export const useShipmentUnLoadingDetailContext = () => {

    const context = React.useContext(ShipmentUnLoadingDetailContext);

    if (!context) throw new Error("Transhipment Detail Context not provided!");

    return context;
}